export class AccountOrganizationNotFoundError extends Error { }
